import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Quels établissements doivent être mis à jour ?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Tous mes établissements',
            [BusinessProfileUpdateStrategy.Current]: "Uniquement l'établissement sélectionné",
          },
        },
      },
      buttons: {
        confirm: 'Confirmer',
      },
    },
  },
  toasts: {
    error: 'Une erreur est survenue, veuillez réessayer ou contacter le support technique',
    success: 'Les modifications ont été enregistrées avec succès !',
  },
};
